import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.payment_history';
export const Component = loadable(
  () => import('./containers/PaymentHistoryContainer')
);
export { default as propsFormatter } from './propsFormatter';
